const e = "_heading1_1om5p_1", t = "_heading1Fixed_1om5p_6", _ = "_heading2_1om5p_20", o = "_heading3_1om5p_30", n = "_secondaryText_1om5p_42", s = "_accentText_1om5p_47", m = "_accentTextFixed_1om5p_52", x = "_smallText_1om5p_64", a = "_smallText_semibold_1om5p_71", c = "_semibold_1om5p_76", l = "_smallText_upper_1om5p_80", i = "_subtitle_1om5p_85", d = "_text_1om5p_92", p = "_text_italic_1om5p_99", T = "_monoText_1om5p_103", g = "_monoText_bold_1om5p_112", h = {
  heading1: e,
  heading1Fixed: t,
  heading2: _,
  heading3: o,
  secondaryText: n,
  accentText: s,
  accentTextFixed: m,
  smallText: x,
  smallText_semibold: a,
  semibold: c,
  smallText_upper: l,
  subtitle: i,
  text: d,
  text_italic: p,
  monoText: T,
  monoText_bold: g
};
export {
  s as accentText,
  m as accentTextFixed,
  h as default,
  e as heading1,
  t as heading1Fixed,
  _ as heading2,
  o as heading3,
  T as monoText,
  g as monoText_bold,
  n as secondaryText,
  c as semibold,
  x as smallText,
  a as smallText_semibold,
  l as smallText_upper,
  i as subtitle,
  d as text,
  p as text_italic
};
